import React from 'react';
import Detail from './DetailView';
import Item from './ItemView';
import Group from './GroupView';
import Footer from './FooterView';
import CornerHeader from './CornerHeaderView';

const renderDetails = (details, groupIndex, itemIndex, even) => {
    return details.map(
        (detail, detailIndex) => {
            return <Detail
                key={`${groupIndex}+${itemIndex}+${detailIndex}`}
                detail={detail}
                even={even} />
        }
    );
};

const renderItems = (items, groupIndex, isPrint) => {
    return items.map(
        (item, itemIndex) => {
            let Details = [];
            if (item.expanded) {
                Details = renderDetails(item.details, groupIndex, itemIndex, item.even);
            }

            return [<Item
                key={`${groupIndex}+${itemIndex}`}
                isPrint={isPrint}
                onClick={item.onClick}
                name={item.name}
                even={item.even}
                expanded={item.expanded} />
            ].concat(Details);
        }
    )
};

export default ({
    groups,
    isPrint,
    principalName,
    hasSpouse,
    spouseName,
}) => {
    const Groups = groups.map(
        (group, groupIndex) => {
            const Items = renderItems(group.items, groupIndex, isPrint);

            return [<Group
                key={`${groupIndex}`}
                {...group} />
            ].concat(
                Items
            ).concat(
                group.footer ? [<Footer
                    key={`${groupIndex}+${-1}`}
                    even={group.even}
                    name={group.footer}
                    className={group.footerClassName || ""} />
                ] : []
            );
        }
    );

    return <div className="table-side">
        <ul>
            {[<CornerHeader
                key={`${-1}`}
                principalName={principalName}
                hasSpouse={hasSpouse}
                spouseName={spouseName}
            />].concat(Groups)}
        </ul>
    </div>;
}